import * as React from 'react';
import { FormattedMessage } from "react-intl";
import Share from "../share/share";
import Tags from '../tags/tags'
import './articleHero.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Watch } from 'scrollmonitor-react';

library.add(faAngleLeft);
 

class ArticleHero extends React.Component {
  render() {
    let theBlock = this.props.block;
    let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    return (
        <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
        <div className="container"> 
            <div className="row">
                <div className="col-12 mb-sm-4">
                    <div className="row">
                        <div className="col-md-4 offset-md-2">
                            <a className='btn btn-link go-back' onClick={() => {this.props.changeRoute(this.props.issueId, "")}} href={'./index.html?issueId='+this.props.issueId+'&lang='+this.props.locale}>
                                <span className="back-arrow"><FontAwesomeIcon icon="angle-left" /></span><FormattedMessage id="General.goBack" defaultMessage="Go back" />
                            </a>
                            <div className="heroIntroBox">
                                <div className="hero-tags"><Tags tags={this.props.articleTags} readTime="" videoId=""/></div>
                                {this.props.pageH1 ? <h1 className="articleTitle">{theBlock.blockTitle}</h1> : <h2 className="articleTitle h1">{theBlock.blockTitle}</h2> }
                                <div className="articleAuthor">{this.props.articleAuthor}</div>
                                <div className="articleReadTime">{this.props.articleReadTime}</div>
                            </div>
                            <Share />
                        </div>
                        <div className="col-md-6">
                            <figure>
                                <div className="is-image">
                                    <img src={baseUrl+this.props.block.blockImage} alt={this.props.block.blockImageAlt}/>
                                </div>
                                {this.props.block.blockImageCaption ? <figcaption>{this.props.block.blockImageCaption}</figcaption> : ""}
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
  }
}

export default Watch(ArticleHero);
